import React from 'react';
import * as S from './styles';
import { AvatarProps } from './types';

/**
 * User avatar
 */
const Avatar: React.FC<AvatarProps> = ({ className, initial, size = 30 }) => (
  <S.Root aria-label="avatar" className={className} $size={size}>
    {initial[0].toUpperCase()}
  </S.Root>
);

export default Avatar;
